import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

declare const _: any;

@Component({
  selector: 'app-status-tracker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './status-tracker.component.html',
  styleUrl: './status-tracker.component.scss'
})
export class StatusTrackerComponent implements OnInit, OnDestroy {
  @Input() currentStep: string;
  @Input() steps: Array<any>;
  @Input() displayKey: string;

  constructor() {}

  showStatus() {
    const base = this;
    this.displayKey = this.displayKey ? this.displayKey : 'status';
    this.currentStep = this.currentStep ? this.currentStep : '';
    const currentStateIndex = _.findIndex(this.steps, function(step){
      return step[base.displayKey].replace(' ', '').toLowerCase() == base.currentStep.replace(' ', '').toLowerCase();
    });
    _.each(this.steps, function(step, index){
      setTimeout(() => {
        if (index <= currentStateIndex) {
          step.class = 'active ';
        }
      }, (index + 1) * 250);
    });
  }

  ngOnInit(): void {
    this.showStatus();
  }

  ngOnDestroy(): void {
  }

}
